import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

interface QueryCtmEventsPayload {
  skip?: number;
  take?: number;
  search?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  [key: string]: any;
}

interface QueryCtmEventsResponse {
  data: any[];
  total: number;
}

const getCtmsApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/ctm/get', {});
  const data = response.data;
  return data?.ctms ?? data?.data ?? (Array.isArray(data) ? data : []);
};

const queryCtmEventsApi = async (payload: QueryCtmEventsPayload): Promise<QueryCtmEventsResponse> => {
  const response = await httpClient.post<QueryCtmEventsResponse>('api/ctm/query', payload);
  return response.data;
};

const updateCtmEventApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/ctm/update', payload);
  return response.data;
};

const updateCtmAssetApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/ctm/update-asset', payload);
  return response.data;
};

export const useCtms = () => {
  return useQuery({
    queryKey: ['ctms'],
    queryFn: getCtmsApi,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useQueryCtmEvents = () => {
  return useMutation({
    mutationFn: queryCtmEventsApi,
  });
};

export const useUpdateCtmEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCtmEventApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ctm-events'] });
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};

export const useUpdateCtmAsset = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCtmAssetApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ctms'] });
      queryClient.invalidateQueries({ queryKey: ['location-details'] });
    },
  });
};
